/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap-button-loader';
import { Panel } from 'react-bootstrap';
import get from 'lodash/get';
import { AddJobButtons } from '..';
import { AdvertiserApi } from '../../../../api';

class WizardFormStepOne extends Component {
  constructor(props) {
    super(props);

    this.state = {
      numberOfJobs: 0,
    };
  }

  componentDidMount() {
    const { account } = this.props;
    if (account.uuid) {
      this.fetchNumberOfJobs();
    }
  }

  fetchNumberOfJobs() {
    const { dispatch, account } = this.props;
    const data = { account_id: account.uuid };

    dispatch(AdvertiserApi.actions.jobs.get(data, (error, success) => {
      if (success) {
        this.setState({ numberOfJobs: success.meta.pagination.total_count });
      }
    }));
  }

  render() {
    const { onClick, account, jobCount } = this.props;


    return (
      <Panel className="create-jobs">
        <Panel.Body>
          <div className="text-center">
            <h3>Add Jobs into your account</h3>
            <p className="wizard-instructions">
              In order for us to create a campaign we need to know what jobs you're looking to fill through this campaign.
            <br />
              To get started, use one of the provided methods to add your jobs into the job inventory.
          </p>
            <span>You currently have { jobCount === 0 ? 'no' : jobCount} jobs in your job inventory.</span>
            <AddJobButtons account={account}/>
            <div className="wizard-form-nav">
              <Button
                onClick={onClick}
                disabled={jobCount > 0 ? false : true}
              >Next</Button>
            </div>
          </div>
        </Panel.Body>
      </Panel>
    );
  }
}

const mapStateToProps = (state) => {
  const { advertiser: { jobs: { data: jobs, loading: jobsLoading } }} = state;

  const jobCount = get(jobs, 'meta.pagination.total_count', 0);

  return {
    jobs,
    jobsLoading,
    jobCount
  };
};

export default connect(mapStateToProps)(WizardFormStepOne);
